module.exports = __webpack_public_path__ + "assets/img/bg.76ce65cc.png";